module.exports = __webpack_public_path__ + "static/wonz-056ed145e5b61a14f91f2457c5999a37.mp4";